module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/new/danny_text-1fc5fa60a6b6ce8e7e5ddd0dfd63d3e1.png";